module.exports = __webpack_public_path__ + "static/scale-model-of-sibley-historic-site-in-minneapolis-minnesota-1267f0d99fd618d9f70b651ce66e5b88.png";